<template>
  <v-navigation-drawer
    v-model="drawer"
    width="700"
    app
    temporary
    right
    class="wost-drawer"
  >
    <div class="navigation-head">
      <span>{{ titleForm }}</span>
    </div>

    <div class="pl-3 pt-3 pr-3" style="height: 80vh;">
      <template>
        <v-row>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.category_gasto_id"
              :items="category_gastos"
              label="Tipo de Gasto"
              outlined
              :item-text="customText"
              item-value="id"
              clearable
              hide-details
              @change="handleChangeTipoGasto"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6">
            <v-autocomplete
              v-model="form.origin"
              ref="origin"
              :value="form.origin"
              :items="origins"
              label="Origen"
              outlined
              :rules="[
                () => !!form.origin || 'Es necesario seleccionar el origen',
              ]"
              hide-details="auto"
              required
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-autocomplete
              v-if="form.origin == 'CUENTA BANCARIA'"
              v-model="form.account_id"
              :items="accounts"
              label="Cuentas"
              outlined
              :item-text="customTextCuentas"
              item-value="id"
              clearable
              hide-details="auto"
            ></v-autocomplete>
            <v-autocomplete
              v-else-if="form.origin == 'CAJA'"
              v-model="form.till_id"
              :items="tills"
              label="Cajas"
              outlined
              :item-text="customTextCajas"
              item-value="id"
              hide-details="auto"
            ></v-autocomplete>
            <v-autocomplete
              v-else
              label="Caja - Cuenta Bancaria"
              outlined
              disabled
              hide-details="auto"
            ></v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-autocomplete
              v-if="type == 1"
              v-model="form.supplier_id"
              :items="suppliers"
              label="Proveedor"
              outlined
              :item-text="customText"
              v-on:keyup.enter="searchProveedor($event)"
              item-value="id"
              :loading="searchingProveedor"
              clearable
              hide-details
              @change="handleChangeProvider"
            ></v-autocomplete>

            <div v-if="type == 2" style="display: flex; align-items: center">
              <v-text-field
                style="width: 90%;"
                v-model="form.document"
                label="Documento"
                outlined
                :loading="searching"
                hide-details="auto"
              ></v-text-field>
              <v-icon style="width: 10%;" @click="handleSearchDocument"
                >fas fa-search</v-icon
              >
            </div>
          </v-col>
        </v-row>

        <v-row v-if="type == 1">
          <v-col cols="4">
            <v-combobox
              v-model="form.type_document"
              :value="form.type_document"
              :items="type_documents"
              outlined
              label="Comprobante"
              hide-details="auto"
            ></v-combobox>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.serie"
              :value="form.serie"
              label="Serie"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.correlative"
              :value="form.correlative"
              label="Correlativo"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="type == 1">
          <v-col cols="6">
            <v-text-field
              v-model="form.name"
              :value="form.name"
              label="Razon Social"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="form.document"
              :value="form.document"
              label="Documento"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row v-if="type == 2">
          <v-col cols="12">
            <v-text-field
              v-model="form.name"
              :value="form.name"
              label="Apellidos y Nombre o Razon Social"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              v-if="type != 3"
              v-model="form.address"
              :value="form.address"
              label="Direccion"
              outlined
              hide-details="auto"
            ></v-text-field>

            <v-autocomplete
              v-if="type == 3"
              v-model="form.worker_id"
              :items="all_workers"
              label="Trabajador"
              outlined
              :item-text="searchWorker"
              item-value="id"
              clearable
              hide-details
              @change="handleChangeWorker"
            ></v-autocomplete>
          </v-col>

          <v-col cols="6">
            <v-menu
              v-model="date_picker_emision"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.date_emision"
                  ref="date_emision"
                  label="Fecha de emision"
                  readonly
                  clearable
                  v-on="on"
                  outlined
                  :rules="[
                    () =>
                      !!form.date_emision || 'Es necesario ingresar una fecha',
                  ]"
                  hide-details="auto"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.date_emision"
                @input="date_picker_emision = false"
                no-title
                locale="es"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="form.total_input"
              ref="total_input"
              :value="form.total_input"
              label="Total"
              outlined
              :rules="[
                () => !!form.total_input || 'Es necesario ingresar un Total',
              ]"
              hide-details="auto"
              required
              type="number"
              @change="handleChangePrice"
            ></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field
              v-model="form.discount_input"
              :value="form.discount_input"
              label="Descuento"
              outlined
              hide-details="auto"
              type="number"
              @change="handleChangePrice"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="form.glosa"
              :value="form.glosa"
              label="Glosa"
              outlined
              hide-details="auto"
            ></v-text-field>
          </v-col>
        </v-row>

        <v-card
          style="height: 24% !important; margin-top: 1rem; font-size: 12px;"
        >
          <v-list>
            <v-list-item class="invoice-summary">
              <v-list-item-content>
                <v-list-item-title>
                  <span class="invoice-discount" style="font-size: 12px;"
                    >Descuento</span
                  >
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span class="invoice-discount">{{
                  form.discount | currency("S/")
                }}</span>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item class="invoice-summary">
              <v-list-item-content>
                <v-list-item-title style="font-size: 12px;">
                  Subtotal
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span>{{ form.subtotal | currency("S/") }}</span>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item class="invoice-summary">
              <v-list-item-content>
                <v-list-item-title style="font-size: 12px;">
                  IGV(18%)
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span>{{ form.igv | currency("S/") }}</span>
              </v-list-item-action>
            </v-list-item>

            <v-divider></v-divider>
            <v-list-item class="invoice-summary">
              <v-list-item-content>
                <v-list-item-title style="font-size: 12px;">
                  Total
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <span>{{ form.total | currency("S/") }}</span>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>
      </template>
    </div>

    <div class="mt-3 pl-3 pt-3 pr-3">
      <template>
        <v-row>
          <v-col cols="6">
            <v-btn block height="40" dark color="red" @click="handleCancel">
              <v-icon class="mr-1" size="16">far fa-times-circle</v-icon>
              Cancelar
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              v-if="action == 'create'"
              dark
              color="success"
              block
              height="40"
              @click="handleStore"
              :disabled="press_button"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="action == 'update'"
              dark
              color="success"
              block
              height="40"
              @click="handleUpdate"
            >
              <v-icon class="mr-1" size="16">far fa-save</v-icon>
              Actualizar
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </div>
    <v-snackbar v-model="cant_register" top color="error">
      {{ message_validation }}
      <v-btn dark text @click="handleCloseMessageValidation">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Array } from "../../helpers/Array";

export default {
  name: "CreateUpdate",
  data() {
    return {
      drawer: false,
      titleForm: null,
      action: null,
      form: {
        id: null,
        category_gasto_id: null,
        origin: null,
        account_id: null,
        till_id: null,
        name: null,
        document: null,
        glosa: "",
        address: null,
        date_emision: null,
        type_document: null,
        total_input: 0.0,
        discount_input: 0.0,
        discount: 0.0,
        subtotal: 0.0,
        igv: 0.0,
        total: 0.0,
        provider_id: null,
        serie: null,
        correlative: null,
        worker_id: null,
      },
      type: 1,
      origins: ["CAJA", "CUENTA BANCARIA"],
      type_documents: ["BOLETA", "FACTURA"],
      searchingProveedor: false,
      date_picker_emision: false,
      press_button: false,
      searching: false,
      message_validation: null,
      cant_register: false,
      // type: Array.categoriaGastoType,
    };
  },
  computed: {
    ...mapState("category-gasto", ["category_gastos"]),
    ...mapState("tills", ["tills"]),
    ...mapState("accounts", ["accounts"]),
    ...mapState("suppliers", ["suppliers"]),
    ...mapState("customers", ["person"]),
    ...mapState("employees", ["all_workers"]),
  },
  methods: {
    ...mapActions("gasto", ["store", "update"]),
    ...mapActions("suppliers", ["getSuppliers"]),
    ...mapActions("customers", ["searchDocument"]),
    async showForm(title, action, gasto = null) {
      await this.clearData();
      this.titleForm = title;
      this.action = action;
      if (gasto) {
        this.setArea(gasto);
      }
      this.drawer = !this.drawer;
    },
    customText(item) {
      let text = item.name;

      return text;
    },
    searchWorker(item) {
      return item.fullname;
    },
    customTextCuentas(item) {
      let text = item.bank.name + " (" + item.number_account + ")";
      return text;
    },
    customTextCajas(item) {
      let text = item.name;

      return text;
    },
    clearData() {
      this.form.category_gasto_id = null;
      this.searching = false;

      this.form.id = null;
      this.form.origin = null;
      this.form.account_id = null;
      this.form.till_id = null;
      this.form.name = null;
      this.form.document = null;
      this.form.glosa = "";
      this.form.address = null;
      this.form.date_emision = null;
      this.form.type_document = null;
      this.form.total_input = 0.0;
      this.form.discount_input = 0.0;
      this.form.discount = 0.0;
      this.form.subtotal = 0.0;
      this.form.igv = 0.0;
      this.form.total = 0.0;

      this.form.supplier_id = null;
      this.form.serie = null;
      this.form.correlative = null;
      this.form.worker_id = null;
      this.clearErrors();
    },
    setArea(gasto) {
      this.form.id = gasto.id;
      this.form.name = gasto.name;
    },
    closeForm() {
      this.clearData();
      this.type = 1;
      this.drawer = false;
    },
    handleCancel() {
      this.closeForm();
    },
    async handleStore() {
      this.press_button = true;
      if (!this.existErrors()) {
        if (this.customValidate()) {
          this.press_button = false;
          return;
        }

        await this.store({ ...this.form, type: this.type });
        this.press_button = false;
        this.closeForm();
      }
      this.press_button = false;
    },
    customValidate() {
      let findError = false;

      if (this.type == 1) {
        if (this.form.serie == null || this.form.serie == undefined) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar una Serie";
          return true;
        }
        if (
          this.form.correlative == null ||
          this.form.correlative == undefined
        ) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar un Correlativo";
          return true;
        }
        if (
          this.form.type_document == null ||
          this.form.type_document == undefined
        ) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar Comprobante";
          return true;
        }

        if (this.form.name == null || this.form.name == undefined) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar una Razon Social";
          return true;
        }
        if (this.form.document == null || this.form.document == undefined) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar un Documento";
          return true;
        }
      }
      if (this.type == 2) {
        if (this.form.name == null || this.form.name == undefined) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar una Razon Social";
          return true;
        }
        if (this.form.document == null || this.form.document == undefined) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar un Documento";
          return true;
        }
      }
      if (this.type == 3) {
        if (this.form.worker_id == null || this.form.worker_id == undefined) {
          this.cant_register = true;
          this.message_validation = "Debe ingresar un Trabajador";
          return true;
        }
      }

      return findError;
    },
    async handleUpdate() {
      if (!this.existErrors()) {
        await this.update(this.form);
        this.closeForm();
      }
    },
    existErrors() {
      let hasErrors = false;

      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) {
          if (!this.form[f]) {
            hasErrors = true;
            console.log(f);
          }
          this.$refs[f].validate(true);
        }
      });

      return hasErrors;
    },
    clearErrors() {
      Object.keys(this.form).forEach((f) => {
        if (this.$refs[f]) this.$refs[f].reset();
      });
    },
    async searchProveedor(event) {
      this.searchingProveedor = true;
      const value = event.target.value;
      if (value.length > 0) {
        await this.getSuppliers({ name: value });
      } else {
        await this.getSuppliers();
      }
      this.searchingProveedor = false;
    },
    handleChangeProvider() {
      if (this.form.supplier_id) {
        const findSupplier = this.suppliers.find(
          (dt) => dt.id == this.form.supplier_id
        );
        if (findSupplier) {
          this.form.name = findSupplier.name;
          this.form.document = findSupplier.ruc;
          this.form.address = findSupplier.address;
        }
      } else {
        this.form.name = null;
        this.form.document = null;
        this.form.address = null;
      }
    },
    handleChangePrice() {
      if (
        Number(this.form.discount_input) <= Number(this.form.total_input) ||
        (this.form.total_input && this.form.discount_input == undefined)
      ) {
        const total_input_aux = Number(this.form.total_input) || 0.0;
        const discount_input_aux = Number(this.form.discount_input) || 0.0;

        let newTotal = total_input_aux - discount_input_aux;
        let newSubtotal = newTotal / 1.18;
        let newIgv = newTotal - newSubtotal;

        this.form.discount = discount_input_aux;
        this.form.subtotal = newSubtotal;
        this.form.igv = newIgv;
        this.form.total = newTotal;
      } else {
        // this.form.discount_input = 0.0;
        this.form.discount_input = 0.0;
      }
    },
    handleChangeTipoGasto() {
      const findTypeGasto = this.category_gastos.find(
        (dt) => dt.id == this.form.category_gasto_id
      );
      if (findTypeGasto) {
        this.type = findTypeGasto.type;

        this.form.id = null;
        this.form.origin = null;
        this.form.account_id = null;
        this.form.till_id = null;
        this.form.name = null;
        this.form.document = null;
        this.form.glosa = "";
        this.form.address = null;
        this.form.date_emision = null;
        this.form.type_document = null;
        this.form.total_input = 0.0;
        this.form.discount_input = 0.0;
        this.form.discount = 0.0;
        this.form.subtotal = 0.0;
        this.form.igv = 0.0;
        this.form.total = 0.0;

        this.form.supplier_id = null;
        this.form.serie = null;
        this.form.correlative = null;
        this.form.worker_id = null;
      }
    },
    async handleSearchDocument() {
      this.searching = true;
      if (this.form.document) {
        let document = this.form.document;
        await this.searchDocument(document);
        this.searching = false;
        if (this.person) {
          let personFounded = Object.assign({}, this.person);
          if (personFounded.document_type == "DNI") {
            this.form.name = personFounded.nombre_o_razon_social;
          } else if (personFounded.document_type == "RUC") {
            this.form.name = personFounded.name;
          }
          this.form.address = personFounded.address;
          // this.customerForm.name = personFounded.name;
          // this.customerForm.surname = personFounded.surname;
        }
      } else {
        this.searching = false;
      }
    },
    handleCloseMessageValidation() {
      this.cant_register = false;
      this.message_validation = null;
    },
    handleChangeWorker() {
      if (this.form.worker_id) {
        const findWorker = this.all_workers.find(
          (dt) => dt.id == this.form.worker_id
        );
        if (findWorker) {
          this.form.name = findWorker.fullname;
          this.form.document = findWorker.dni;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-list-item__content {
  padding: 0px !important;
}

.v-list-item {
  min-height: 30px !important;
}

.v-list-item__action {
  margin: 0px !important;
}

.invoice-discount {
  color: #f44336;
}
</style>
